import axios from '@/libs/api.request'
// 保存feedback
export const saveFeedback = data => {
  return axios.request({
    url: '/feedback/save',
    data,
    method: 'POST'
  })
}
// 查看feedback
export const getFeedbackDetail = data => {
  return axios.request({
    url: '/feedback/detail',
    data,
    method: 'POST'
  })
}
